import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_view_tabs = _resolveComponent("ontos-view-tabs")!

  return (_ctx.hasKanban)
    ? (_openBlock(), _createBlock(_component_ontos_view_tabs, {
        key: 0,
        views: _ctx.views,
        "model-value": _ctx.current
      }, null, 8, ["views", "model-value"]))
    : _createCommentVNode("", true)
}